"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateName;
var MAX_NAME_LENGTH = 50;
var punctuationRegex = /[!"#$%&'()*+,./:;<=>?@^_`{|}~\\]+/;
/**
 * validateName is used to validate names for forms. This prevents names from being too long
 * or containing illegal characters.  We introduced this in ecomm-front-end as a result of
 * someone phishing using our /create-account form.
 * @param {String} name Name to validate
 */

function validateName(name) {
  // Test name length
  // https://ux.stackexchange.com/a/55540
  if (name && name.length > MAX_NAME_LENGTH) {
    return 'Name must be 50 characters or less.';
  } // Test for punctuation
  // This same regex is checked in ecomm-core, see PRs for STORE-2790
  // See Facebook's Name Policy https://www.facebook.com/help/292517374180078


  if (punctuationRegex.test(name)) {
    return 'Punctuation not allowed.';
  }

  return null;
}